import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerAccessControlPage } from './pages/customer-access-control/customer-access-control.page';
import { CustomerEditPage } from './pages/customer-edit/customer-edit.page';
import { CustomerOnboardingPage } from './pages/customer-onboarding/customer-onboarding.page';
import { CustomerRelationshipMapPage } from './pages/customer-relationship-map/customer-relationship-map.page';
import { CustomerOverviewPage } from './pages/customer-overview/customer-overview.page';
import { CustomersListPage } from './pages/customers-list/customers-list.page';
import { CrpAddPage } from './pages/crp-add/crp-add.page';
import { CrpEditPage } from './pages/crp-edit/crp-edit.page';
import { CustomersBatchUploadPage } from './pages/customers-batch-upload/customers-batch-upload.page';

import { ScreeningGuard } from 'modules/shared/guards/screening.guards';
import { RiskAssessmentGuard } from 'modules/shared/guards/risk-assessment.guards';
import { CustomerInDomainGuard } from './guards/customer-in-domain.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CustomersListPage,
        pathMatch: 'full'
      }, {
        path: 'onboarding',
        component: CustomerOnboardingPage
      }, {
        path: 'batch-upload',
        component: CustomersBatchUploadPage
      }, {
        path: ':id',
        children: [
          {
            path: '',
            component: CustomerOverviewPage,
            pathMatch: 'full'
          }, {
            path: 'access-control',
            component: CustomerAccessControlPage
          }, {
            path: 'edit',
            component: CustomerEditPage
          }, {
            path: 'edit/crp-add',
            component: CrpAddPage
          }, {
            path: 'edit/crp-edit/:crpId',
            component: CrpEditPage
          }, {
            path: 'relationship-map',
            component: CustomerRelationshipMapPage
          }, {
            path: 'screening',
            loadChildren: () => import('modules/screening/screening.module').then(m => m.ScreeningModule),
            canActivate: [ScreeningGuard],
          }, {
            path: 'risk-assessment',
            loadChildren: () => import('modules/risk-assessment/risk-assessment.module').then(m => m.RiskAssessmentModule),
            canActivate: [RiskAssessmentGuard],
          }
        ],
        canActivate: [CustomerInDomainGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    CustomerInDomainGuard
  ]
})
export class CustomersRoutingModule { }
